import Comments from './Comments'
import GcModal from './GcModal'
import DeleteModal from './DeleteModal'
import FrontendAlerts from './FrontendAlerts'
import FollowersCount from './FollowersCount'
import ReportModal from './ReportModal'
import DropdownButton from './DropdownButton'
import LoadingSpinner from './LoadingSpinner'
import MentionList from './MentionList'
import PersistentTooltip from './PersistentTooltip'
import TagInput from './TagInput'
import { Multiselect } from 'vue-multiselect'
import { VPopover } from "v-tooltip";

export default {
    Comments,
    GcModal,
    DeleteModal,
    FrontendAlerts,
    FollowersCount,
    ReportModal,
    DropdownButton,
    LoadingSpinner,
    MentionList,
    PersistentTooltip,
    TagInput,
    Multiselect,
    VPopover
}